import React,{ PureComponent } from 'react'
import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';

/**
 *  目标客户 认证未认证图标
 * size 尺寸：宽度 高度
 * color  默认黑色 透明背景 black, white ：白色透明背景
 *
 **/
export default  class IconVerified extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        // color: PropTypes.string,
        isTargetCustomer:"",
    }
    static defaultProps = {
        size:14,
        color:"#333"
    };
    setIcon =()=>{
        const {isTargetCustomer,size,color,className="" } = this.props;
        return(isTargetCustomer==1?<i className={`font-green ri-verified-badge-fill${className?(" "+className):""}`} style={{fontSize:size+"px"}}></i>:<svg t="1734058022245"
                                                                                                                                                 className={`icon${className?(" "+className):""}`} viewBox="0 0 1024 1024"
                 version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="23788" width={size} height={size}>
            <path
                d="M512 0l25.6 17.066667s68.266667 51.2 162.133333 85.333333c93.866667 42.666667 196.266667 42.666667 196.266667 42.666667h42.666667v426.666666c0 213.333333-281.6 443.733333-426.666667 443.733334-145.066667 0-426.666667-230.4-426.666667-443.733334v-426.666666h42.666667s93.866667 0 196.266667-42.666667C426.666667 59.733333 486.4 17.066667 486.4 17.066667L512 0z m128 341.333333L520.533333 460.8 401.066667 341.333333l-59.733334 59.733334 119.466667 119.466666L341.333333 640l59.733334 59.733333 119.466666-119.466666 119.466667 119.466666 59.733333-59.733333-119.466666-119.466667 119.466666-119.466666-59.733333-59.733334z"
                fill="#606060" p-id="23789"></path>
        </svg>);
    }
    /**
     * 点击事件
     */
    onClick=()=>{
        if(this.props.onClick)this.props.onClick();
    }
    render() {
        return (<Icon component={this.setIcon} onClick={()=>this.onClick()} />);
    }
}

